import script from "./ShakyoHome.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoHome.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoHome.vue?vue&type=style&index=0&id=e6972420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6972420"]])

export default __exports__